export const humanReadableDate = (date) =>
  !isNaN(date) &&
  date.toLocaleDateString('default', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  })

export const humanReadableTime = (date) =>
  !isNaN(date) &&
  date.toLocaleTimeString('default', {
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short'
  })
